export default __webpack_public_path__ + "img/ReynoldsRewards_Logo-01.jpg";